// extracted by mini-css-extract-plugin
export default {"header":"Header_header__+ZXQ8","logoWrapper":"Header_logoWrapper__NZ0Ia","logo":"Header_logo__njp2l","nav":"Header_nav__KllbC"};